import { Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { Label } from '../label/label';

export type ToggleSwitchLabelPosition = 'top' | 'bottom' | 'left' | 'right';

@Component({
  selector: 'elcia-toggle-switch',
  imports: [ToggleSwitchModule, ReactiveFormsModule, Label],
  templateUrl: './toggle-switch.html',
  styleUrl: './toggle-switch.scss',
  host: {
    '[class]': 'layoutClass()',
  },
})

export class ToggleSwitch {
  control = input.required<FormControl<boolean>>()
  label = input<string>()
  labelPosition = input<ToggleSwitchLabelPosition>('left')

  protected layoutClass = computed(() => {
    switch (this.labelPosition()) {
      case 'top': return 'flex-col';
      case 'bottom': return 'flex-col-reverse';
      case 'right': return 'flex-row-reverse';
      default: return 'flex-row';
    }
  })
}
